export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  keepAlive: false,
  dynamicParam: '/:mode?/:id?',
  title: '收款单创建',
} as TCommon.RouteConfig
